export default function(username_val) {
    if (!this.validateUsernameLegacy(username_val)) {
        return false;
    }
    this.disableInputs();
    this.loading = true;
    let form_data = new FormData;
    form_data.append('action', ajax_var.action_check_username);
    form_data.append('username', username_val);
    form_data.append('nonce', ajax_var.nonce);

    axios.post(ajax_var.url, form_data).then((res) => {
        this.enableInputs();
        if (res.status == 200) {
            this.loading = false;
            if (res.data != false) {
                this.errorMessage = "Sorry, this username is already in use. Try something else!";
                return false;
            } else {
                this.errorData.username = "";
                this.$router.push('/password/');
            }
        }
    })
    .catch(error => {
        console.log(error);
    });
}
